module.exports = __webpack_public_path__ + "img/noche-2.a15a0066.jpg";